module.exports = __webpack_public_path__ + "img/sliders-02.289b5af1.svg";